import { FluentResource } from '@fluent/bundle';
import { makeStringIds } from './localization-string-util';

export enum MobileAppsStrings {
    text_body_configure,
    text_header_unityField,
}

export const mobileAppsStrings = makeStringIds<typeof MobileAppsStrings>('mobileApps', MobileAppsStrings);

export function  getMobileAppsFluentResource(): FluentResource {
    // Translation can be done by assigning a string to each property
    // in the mobileAppsStrings object created above.
    return new FluentResource('');
}

